import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from '../../../../../../ng2-bootstrap-modal/dialog.component';
import {DialogService} from '../../../../../../ng2-bootstrap-modal/dialog.service';
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {HostingService} from "../../hosting.service";
import { filter, first } from "rxjs";

@Component({
    selector: 'db-remove-redirect-dialog',
    templateUrl: './remove-redirect-dialog.component.html',
    styleUrls: ['./remove-redirect-dialog.component.scss'],
    standalone: false
})
export class RemoveRedirectDialogComponent extends DialogComponent<null, Boolean> implements OnInit {

  @Input() websiteId: number;
  @Input() redirect: any;
  @Input() multipleRules: boolean;

  public loading: boolean;
  public changes: any;

  constructor(
    private _dialogService: DialogService,
    private _hostingService: HostingService
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {

  }

  public cancel(): void {
    this.result = false;
    this.close();
  }

  public confirm(): void {
    this.loading = true;
    this._hostingService.removeRedirect( this.websiteId, this.redirect.domainNameId ? this.redirect.domainNameId : 0, this.redirect.id )
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          this.result = true;
          this.close();
        }
        this.loading = false;
      });
  }

  public removeRedirects(): void {
    this.loading = true;
    let rulesIds = [];
    this.redirect.forEach(item => rulesIds.push(item.id));
    this._hostingService.removeRedirectRules(this.websiteId, rulesIds)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          this.result = true;
          this.close();
        }
        this.loading = false;
      });
  }

}
